import { render, staticRenderFns } from "./VideoRoomMeeting.vue?vue&type=template&id=6045e6a3"
import script from "./VideoRoomMeeting.vue?vue&type=script&lang=js"
export * from "./VideoRoomMeeting.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomMeeting.vue?vue&type=style&index=0&id=6045e6a3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports